// Narrative order chosen by Mark. Dates are omitted until the updated CV is supplied.
export const chain = [
  {
    id: 'evrald', name: 'Evrald', theme: 'Trust', label: 'Genesis',
    transactions: ["Started with trust problems in international trade.", "Explored referrals and shared evidence between companies."],
    stateChange: "A record can preserve a claim. Establishing whether that claim is true is a separate problem.",
    logo: '/assets/projects/Evrald/cover.jpg', logoStyle: 'evrald',
    summary: 'Can trust between companies become verifiable information?',
    detail: 'International trade was my starting point. At Evrald, we explored referrals and shared evidence as a way to build a reputation network between companies.',
  },
  {
    id: 'dhow', name: 'Dhow', theme: 'Ownership', label: 'Art & provenance',
    transactions: ["Explored connecting Chinese artists with global collectors.", "Investigated provenance for physical artworks."],
    stateChange: "A unique digital record does not, by itself, establish the authenticity of a physical object.",
    logo: '/assets/projects/dhow/cover.jpg', logoStyle: 'dhow',
    summary: 'What connects a physical object to its digital record?',
    detail: 'An attempt to connect Chinese artists with global collectors brought the question of provenance into focus: what can an onchain record actually tell us about physical art?',
    href: 'https://dhow.cn/', linkLabel: 'Visit Dhow',
  },
  {
    id: 'navi', name: 'NAVI', theme: 'Infrastructure', label: 'Protocol engineering',
    transactions: ["Worked on Volo, Astros DCA and NAVI.", "Built backend services, contract integrations and protocol data flows."],
    stateChange: "My focus moved from what a product promises to the systems that make it work.",
    logo: '/assets/brands/navi.svg', logoStyle: 'navi',
    summary: 'Building the systems behind onchain products.',
    detail: 'Across Volo, Astros DCA and NAVI, I worked on backend services, contract integrations and protocol data—the engineering that connects a protocol to its users.',
    href: 'https://app.naviprotocol.io/', linkLabel: 'Visit NAVI',
  },
  {
    id: 'knewit', name: 'Knewit', theme: 'Markets', label: 'Product building',
    transactions: ["Built prediction-market creation and trading flows.", "Connected real-time data with the product and its infrastructure."],
    stateChange: "A market needs more than a trading mechanism. People need a product they can understand and use.",
    logo: '/assets/brands/knewit-wordmark.svg', logoStyle: 'knewit',
    summary: 'Turning opinions into a market people can use.',
    detail: 'Building a prediction market meant working across the whole product: market creation, trading flows, real-time data and the infrastructure supporting them.',
    href: 'https://dongleapp.com/', linkLabel: 'Visit Knewit',
  },
  {
    id: 'mantle', cardHref: 'https://x.com/MarkChen_PM/status/2100247259136864313', href: 'https://x.com/MarkChen_PM/status/2100247259136864313', linkLabel: 'View post on X', name: 'Mantle', theme: 'Execution', label: 'Blockchain systems',
    logo: '/assets/brands/mantle.svg', logoStyle: 'mantle',
    transactions: ["Moved deeper into blockchain infrastructure."],
    stateChange: "Execution and settlement became the next questions to explore.",
    summary: 'Looking deeper into how the chain works.',
    detail: 'The next part of my work moved closer to blockchain infrastructure, and the questions behind execution and settlement.',
  },
  {
    id: 'now', name: 'Now', theme: 'Still building', label: 'Open-ended',
    transactions: ["Exploring trust, ownership and markets."],
    stateChange: "Still forming. The next block is open-ended.",
    summary: 'The next block is still being written.',
    detail: 'I’m still exploring the connections between trust, ownership and markets—and what to build next.',
    href: 'mailto:jc10691@nyu.edu', linkLabel: 'Let’s talk',
  },
];
